export default "__VITE_ASSET__aeff633c__"